// In production, slug is in subdomain. In dev (or harness mode), slug is the first path segment.

const usePathSlug = process.env.NODE_ENV !== 'production' || process.env.REACT_APP_HARNESS === 'true';

/** Get current slug from URL (subdomain in prod, first path segment in dev/harness) */
export function getSlug(): string | null {
    const { hostname, pathname } = window.location;

    if (usePathSlug) {
        const segments = pathname.split('/').filter(Boolean);
        return segments[0] ?? null;
    }

    // Format: {slug}.book-organizabot.com
    const parts = hostname.toLowerCase().split('.');
    return parts.length >= 3 ? parts[0] : null;
}

/** Get current app-relative path (strips slug segment in dev/harness) */
export function getPath(): string {
    const { pathname } = window.location;
    if (usePathSlug) {
        const segments = pathname.split('/').filter(Boolean);
        return '/' + segments.slice(1).join('/');
    }
    return pathname;
}

/** Navigate to an app path (adds slug prefix in dev/harness) */
export function navigate(appPath: string, options?: { replace?: boolean }): void {
    const slug = getSlug();
    const fullPath = usePathSlug ? `/${slug}${appPath}` : appPath;
    if (options?.replace) {
        window.history.replaceState({}, '', fullPath);
    } else {
        window.history.pushState({}, '', fullPath);
    }
    window.dispatchEvent(new PopStateEvent('popstate'));
}
